import { z } from 'zod';
import { applicantMetadata, beneficialOwnersSchema } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

export const updateBeneficialOwnerSchema = z
  .object({
    step: z.literal(ApplicationStep.BeneficialOwner),
    enterprise: beneficialOwnersSchema,
    applicant: applicantMetadata.pick({ type: true }),
  })
  .and(baseApplicationStep);
